import { render, staticRenderFns } from "./DetailTill.vue?vue&type=template&id=41c5ab2a&scoped=true&"
import script from "./DetailTill.vue?vue&type=script&lang=js&"
export * from "./DetailTill.vue?vue&type=script&lang=js&"
import style0 from "./DetailTill.vue?vue&type=style&index=0&id=41c5ab2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5ab2a",
  null
  
)

export default component.exports